//Global imports
import { useSortable } from '@dnd-kit/sortable';

const DragHandle = ({ id }: { id: string }) => {
    const { attributes, listeners, setActivatorNodeRef } = useSortable({ id });

    return (
        <div
            ref={setActivatorNodeRef}
            {...listeners}
            {...attributes}
            style={{ cursor: 'grab' }}
            className="d-flex flex-column justify-content-center align-items-center h-100 px-2 gap-1"
        >
            {[...Array(3)].map((_, rowIndex) => (
                <div key={rowIndex} className="d-flex gap-1">
                    {[...Array(2)].map((_, dotIndex) => (
                        <div
                            key={dotIndex}
                            className="bg-secondary rounded-circle"
                            style={{ width: '4px', height: '4px' }}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default DragHandle;
